import React, { Fragment, useEffect } from 'react';
import { RootState } from 'ReduxStore/store';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from 'Components/Reusable/Categories/categories.style';
import category from 'Assets/img/svg/categoriesImage.svg';
import Header from 'Components/Header/Header';
import { categories } from 'Utils/options';
import MenuCard from 'Components/Reusable/Menu/MenuCard';
import { getMilestoneCategories, getAgeGroup } from 'ReduxStore/milestones/Action';
import { milestoneUseStyles } from './milestones.style';
import { changeIdentities, yearCalculator } from 'Helpers';
import ClipLoader from 'react-spinners/ClipLoader';
import Error from 'Components/Timeline/Error'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Redirect, useHistory } from 'react-router-dom';
import { GetAllKids } from 'ReduxStore/children/Action';


const ListMilestonesCategory = () => {
	const classes = useStyles();
	const newClasses = milestoneUseStyles();
	const matches = useMediaQuery('(max-width:768px)');
	const dispatch = useDispatch();
	const history = useHistory();
	const getUpcoming =  (milestone:any) => {
		if (milestone !== undefined){
			const upcoming = milestone?.Milestones &&  milestone?.Milestones?.filter((achieved:any) => achieved.MilestoneAchieveds.length == 0);
			return milestone?.Milestones ? upcoming.length : '0'
		}
		return '0'
		
	}
	useEffect(() => {
		dispatch(getMilestoneCategories());
		dispatch(getAgeGroup());
		dispatch(GetAllKids());
	}, []);
	const milestoneCategories = useSelector((state: RootState) => state.milestones.welcome);
	const ageGroupData = useSelector((state:RootState) => state.milestones.ageGroup)
	const errors = useSelector((state:RootState) => state.milestones.error)
	const children = useSelector((state: RootState) => state.children.children);

	const childName = localStorage.getItem('currentChild');
	const getChildId = JSON.parse(localStorage.getItem('currentChildId') || '{}');
	const child = children && children.find(child => child.id === parseInt(getChildId));
	const milestoneLink = (id:string) => {
		// return history.push(`/${id}`)
		return window.open(`/${id}`,'_self')
	}
	// eslint-disable-next-line no-console
	console.log(errors,"are here")
	return (
		<Fragment>
			<div className="">
				<Header />
				<section style={{ background: '#FBCC3E' }}>
					<div style={{ background: `url(${category})`, height: '12rem' }}>
						<h5 className={newClasses.nameText}>{child && child.fullName}</h5>
						<h5 className={newClasses.ageText}>{yearCalculator(child?.dateOfBirth)}</h5>
						<h5 className={newClasses.text}>{ageGroupData && changeIdentities(ageGroupData?.description,child?.fullName,child?.gender)}</h5>
					</div>
				</section>
				<ul className={classes.listItems}>
					{  milestoneCategories ? (
						milestoneCategories?.map((milestone, i) => (
							<div key={milestone.id}>
								<li className="my-3">
									<MenuCard
										url={`upcoming-milestones/${milestone.id}`}
										image={matches ? categories[i].bgImageMobile :categories[i].backgroundImage }
										type={milestone.title}
										common={{ width: '100%', height: '80.74px' }}
										description={categories[i].description}
										icon={categories[i].icon}
										no={milestone && getUpcoming(milestone)}
										isCategory
										onClick={milestoneLink}
									/>
								</li>
							</div>
							
						))
					) : (
						<div className={classes.loading}>
							{errors ? (
								<Error errors={errors} id={child?.id} />
							) : (
								<div className={classes.loading}>
									<h4>Wait a moment ...</h4>
									<ClipLoader color={'#7FD6DD'} loading={true} size={30} />
								</div>
							)}
						</div>
					)}
				</ul>
			</div>
		</Fragment>
	);
};

export default ListMilestonesCategory;
